/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiInvoiceListSortBy = typeof GetApiInvoiceListSortBy[keyof typeof GetApiInvoiceListSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiInvoiceListSortBy = {
  createdAt: 'createdAt',
  date: 'date',
  datePaid: 'datePaid',
  category: 'category',
  recipientFullName: 'recipientFullName',
  amount: 'amount',
  paymentInfo: 'paymentInfo',
  senderPaymentMethod: 'senderPaymentMethod',
  status: 'status',
} as const;
